/**
 * Format an integer cents amount as a Rand string, e.g. 123456 -> "R1,234.56".
 */
export function formatRand(cents: number): string {
  return 'R' + ((cents || 0) / 100).toLocaleString('en-US', {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  });
}
